export default __webpack_public_path__ + "static/media/student_image.d9ef6016.jpg";